export enum ReduxErrorTypes {
  OUTPUT_EXPRESSION_NOT_FOUND = 'OUTPUT_EXPRESSION_NOT_FOUND',
  INVALID_ACTION_ID = 'INVALID_ACTION_ID',
  INVALID_THRESHOLD_ID = 'INVALID_THRESHOLD_ID',
  INVALID_DATAROUTE_ID = 'INVALID_DATAROUTE_ID',
  INVALID_ACTION_TYPE = 'INVALID_ACTION_TYPE',
}

export enum EditorContainerType {
  MODAL = 'modal',
  PAGE = 'page',
}

export const THRESHOLD_UPDATE_TYPE = {
  VALUE: 'value',
  LEFT_ACTION: 'leftAction',
  LEFT_ATTRIBUTE: 'leftAttribute',
  RIGHT_ACTION: 'rightAction',
  RIGHT_ATTRIBUTE_ID: 'rightAttributeId',
} as const;

export const THRESHOLD_FIELD_NAME = {
  OPERATOR: 'operator',
  RIGHT_ATTRIBUTE_VALUE: 'right.attributeValue',
  RIGHT_REASON_CODE_GROUP: 'right.reasonCodeGroup',
  RIGHT_REASON_CODE_GROUP_ID: 'right.reasonCodeGroupId',
  RIGHT_LEFT_TAG_ACTION_RESULT: 'right.leftTagActionResult',
} as const;

export type ThresholdFieldName =
  (typeof THRESHOLD_FIELD_NAME)[keyof typeof THRESHOLD_FIELD_NAME];
